"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = require("inversify");
var Symbol = require("es6-symbol");
var _1 = require("./");
var TYPES = {
    TemplatingBatchClient: Symbol("TemplatingBatchClient"),
    TemplatingBatchRoute: Symbol("TemplatingBatchRoute"),
    TemplatingClient: Symbol("TemplatingClient"),
    TemplatingRoute: Symbol("TemplatingRoute")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.TemplatingBatchRoute).to(_1.TemplatingBatchRoute);
    bind(TYPES.TemplatingBatchClient).to(_1.TemplatingBatchClient);
    bind(TYPES.TemplatingRoute).to(_1.TemplatingRoute);
    bind(TYPES.TemplatingClient).to(_1.TemplatingClient);
});
exports.diModule = diModule;
